<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé ou non à jour : données indisponibles (voir docs/backend-brief-hr2.md).</div>
}

<!-- La semaine d'une ligne en RÉDUCTION. Elle sert d'aperçu aux deux glissés de la grille — c'est
     elle qui dit ce qu'on a réellement en main : des créneaux, et non une personne. Partagée pour
     que les deux aperçus ne se mettent jamais à diverger. -->
<ng-template #weekStrip let-row="row">
	<span class="week-strip">
		@for (dayIdx of visibleDayIndices; track dayIdx) {
			<span class="strip-day">
				<span class="strip-day-name">{{ dayLabels[dayIdx].slice(0, 2) }}</span>
				<span class="strip-lane">
					@for (bar of row.cells[dayIdx]; track $index) {
						<span class="strip-bar" [style.left.%]="bar.left" [style.width.%]="bar.width"
							[style.background]="row.color"></span>
					}
				</span>
			</span>
		}
	</span>
</ng-template>

<form [formGroup]="headerForm" (ngSubmit)="onSubmit()">
	<div class="flexrow hr-header">
		<h2>Horaires types</h2>

		<mat-form-field class="pick-store">
			<mat-label>Établissement</mat-label>
			<mat-select [formControl]="storeCtrl">
				@for (s of stores; track s.id) {
					<mat-option [value]="s.id">{{ s.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field class="pick-activity">
			<mat-label>Service</mat-label>
			<mat-select [formControl]="activityCtrl">
				@for (a of storeActivities; track a.id) {
					<mat-option [value]="a.id">{{ a.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<!-- Plusieurs grilles se succèdent sur ce service (fenêtres de validité) : on se déplace d'une
		     période à l'autre. Pas de liste déroulante — il peut y en avoir des centaines ; le
		     butinage se fait dans « Tous les horaires », qui sait filtrer. -->
		@if (schedule) {
			<div class="period-nav" [class.creating]="creating">
				<button mat-icon-button type="button" [disabled]="!hasPrevPeriod" (click)="onStepPeriod(-1)"
					matTooltip="Période précédente" aria-label="Période précédente">
					<mat-icon>chevron_left</mat-icon>
				</button>
				<span class="period-text" [matTooltip]="creating ? 'Cette grille n\'est pas encore enregistrée' : periodLabel(schedule)">
					@if (creating) { Nouvelle grille } @else { {{ periodShort(schedule) }} }
					@if (periodIsCurrent) { <span class="now-chip">en cours</span> }
				</span>
				<button mat-icon-button type="button" [disabled]="!hasNextPeriod" (click)="onStepPeriod(1)"
					matTooltip="Période suivante" aria-label="Période suivante">
					<mat-icon>chevron_right</mat-icon>
				</button>
				@if (periods.length > 1 && !creating) {
					<span class="period-count">{{ periodIndex + 1 }}/{{ periods.length }}</span>
				}
			</div>
		}

		@if (dirty) { <span class="dirty-chip">Modifications non enregistrées</span> }
		<span class="spacer"></span>

		<!-- Jours de fermeture du service : masqués par défaut, réaffichés par le toggle. -->
		@if (closedDaysCount > 0 || showClosedDays) {
			<mat-slide-toggle class="closed-toggle" [checked]="showClosedDays" (change)="onToggleClosedDays($event.checked)"
				matTooltip="Afficher aussi les jours où le service n'ouvre pas">Jours fermés</mat-slide-toggle>
		}

		<button mat-icon-button type="button" matTooltip="Nom, rotation, activation du planning"
			aria-label="Réglages du planning" (click)="showSettings = !showSettings" [class.on]="showSettings">
			<mat-icon>tune</mat-icon>
		</button>
		<!-- Le document qu'on affiche dans l'entreprise : une grille par semaine du cycle,
		     avec le calendrier qui dit laquelle s'applique quelle semaine. -->
		<button mat-icon-button type="button" [disabled]="!schedule" (click)="onPrint()"
			matTooltip="Imprimer ces horaires types (toutes les semaines du roulement)" aria-label="Imprimer les horaires types">
			<mat-icon>print</mat-icon>
		</button>
		<button mat-stroked-button type="button" (click)="onOpenList()">Tous les horaires</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="saving || !schedule" id="saveschedulebutton">
			{{ saving ? 'Enregistrement…' : 'Enregistrer' }}
		</button>
	</div>

	@if (showSettings && schedule) {
		<div class="flexrow settings-row">
			<mat-form-field class="wide">
				<mat-label>Nom du planning</mat-label>
				<input matInput formControlName="name" placeholder="Rempli tout seul : Établissement — Service">
			</mat-form-field>
			<mat-form-field>
				<mat-label>Rotation</mat-label>
				<mat-select formControlName="cycle_weeks">
					@for (c of cycleChoices; track c) {
						<mat-option [value]="c">{{ c === 1 ? 'Semaine fixe' : c + ' semaines' + (c === 2 ? ' (paire / impaire)' : '') }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field>
				<mat-label>La semaine 1 commence le…</mat-label>
				<input matInput [matDatepicker]="anchorPicker" formControlName="anchor_monday">
				<mat-datepicker-toggle matIconSuffix [for]="anchorPicker"></mat-datepicker-toggle>
				<mat-datepicker #anchorPicker></mat-datepicker>
				<mat-hint>Ramené au lundi de la semaine choisie</mat-hint>
			</mat-form-field>
			<mat-form-field>
				<mat-label>En vigueur à partir du</mat-label>
				<input matInput [matDatepicker]="startPicker" formControlName="datstart">
				<mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
				<mat-datepicker #startPicker></mat-datepicker>
				<mat-hint>Vide = depuis toujours</mat-hint>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Jusqu'au (inclus)</mat-label>
				<input matInput [matDatepicker]="endPicker" formControlName="datend">
				<mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
				<mat-datepicker #endPicker></mat-datepicker>
				<mat-hint>Vide = sans fin</mat-hint>
			</mat-form-field>
			<mat-slide-toggle formControlName="is_active">Actif</mat-slide-toggle>
			@if (schedule.id > 0) {
				<button mat-stroked-button type="button" (click)="onReplaceFrom()">
					<mat-icon>event_repeat</mat-icon> Nouveaux horaires à partir du…
				</button>
			}
		</div>
	}

	<div class="pagecontent">
		@if (!loaded) {
			<div class="hr-loading">Chargement…</div>
		} @else if (storeActivities.length === 0) {
			<div class="hr-empty">
				Cet établissement n'a pas encore de service.
				<a routerLink="/hr/organization">Déclarer ses services</a> (Magasin, Livraison…), puis revenez ici.
			</div>
		} @else if (schedule) {

			<div class="hint-row">
				Glissez sur une case pour peindre un créneau, tirez ses bords pour ajuster,
				cliquez pour saisir les heures au clavier. La bande « Présence » s'allume en rouge
				quand l'effectif passe sous le minimum exigé.
			</div>
			<!-- Deux poignées, deux gestes qu'on confond vite : autant les nommer une fois pour
			     toutes, avec leur icône, plutôt que de laisser deviner. -->
			<div class="hint-row">
				<mat-icon class="inline-hint">drag_indicator</mat-icon>
				à gauche d'un nom : <b>déplacer la personne et son emploi du temps</b> dans la liste —
				c'est cet ordre-là qui est enregistré.
				<span class="hint-sep">·</span>
				<mat-icon class="inline-hint">swap_horiz</mat-icon>
				au bord de la colonne : <b>emporter la ligne de créneaux</b> et la lâcher plus haut ou
				plus bas, sur un autre salarié, pour intervertir les deux semaines.
			</div>

			@if (weekIndexes.length > 1) {
				<div class="cycle-hint">
					<mat-icon>info</mat-icon>
					Cette semaine réelle correspond à la <strong>&nbsp;Semaine {{ currentWeekIndex + 1 }}&nbsp;</strong> du cycle.
				</div>
			}

			<mat-tab-group [(selectedIndex)]="selectedTab" class="week-tabs">
				@for (wi of weekIndexes; track wi) {
					<mat-tab [label]="'Semaine ' + (wi + 1) + (wi === currentWeekIndex && weekIndexes.length > 1 ? ' •' : '')">

						@if (weekIndexes.length > 1) {
							<div class="flexrow tab-tools">
								<span class="spacer"></span>
								<mat-form-field class="copy-target">
									<mat-label>Copier cette semaine vers…</mat-label>
									<mat-select [formControl]="copyTargetCtrl">
										@for (target of weekIndexes; track target) {
											@if (target !== wi) {
												<mat-option [value]="target">Semaine {{ target + 1 }}</mat-option>
											}
										}
									</mat-select>
								</mat-form-field>
								<button mat-stroked-button type="button" (click)="onCopyWeek(wi)" [disabled]="copyTargetCtrl.value === null">
									<mat-icon>content_copy</mat-icon>&nbsp;Copier
								</button>
							</div>
						}

						<div class="grid-scroll">
							<table class="bars-grid">
								<thead>
									<tr>
										<th class="name-col">Employé</th>
										@for (dayIdx of visibleDayIndices; track dayIdx) {
											<th class="day-head" [class.closed]="closedDay[dayIdx]">
												{{ dayLabels[dayIdx] }}
												<!-- Ouverture en vert, fermeture en rouge, heures rondes en gris : la même
												     lecture que la frise du planning. -->
												<div class="hour-scale">
													@for (t of dayScales[dayIdx]; track t.pct) {
														<span class="hour-label" [class.open]="t.kind === 'open'" [class.close]="t.kind === 'close'"
															[style.left.%]="t.pct"
															[matTooltip]="t.kind === 'open' ? 'Ouverture' : t.kind === 'close' ? 'Fermeture' : ''">{{ t.label }}</span>
													}
												</div>
											</th>
										}
										<th class="total-col">Total</th>
									</tr>
								</thead>
								<!-- La liste des LIGNES : on y déplace une personne AVEC son emploi du temps,
								     comme on réordonne les livraisons d'une tournée. L'ordre obtenu s'enregistre
								     avec la grille (`data.member_seq`) — voir hr-roster.ts. -->
								<tbody cdkDropList [cdkDropListData]="grids[wi]" (cdkDropListDropped)="onRowDrop($event)">
									<tr class="presence-row">
										<td class="name-col presence-label">Présence</td>
										@for (dayIdx of visibleDayIndices; track dayIdx) {
											<td class="presence-cell">
												<div class="lane">
													@for (seg of presence[wi][dayIdx]; track $index) {
														<div class="seg" [class.low]="seg.low" [class.zero]="seg.count === 0 && !seg.low"
															[style.left.%]="seg.left" [style.width.%]="seg.width" [title]="seg.label">
															@if (seg.width > 7) { {{ seg.count }} }
														</div>
													}
												</div>
											</td>
										}
										<td class="total-col"></td>
									</tr>
									@for (row of grids[wi]; track row.id_employee) {
										<!-- La LIGNE entière se déplace : la personne emmène son emploi du temps.
										     L'aperçu reprend le nom ET la semaine — c'est bien tout le bloc qui bouge.
										     `slots-source` : la ligne dont on vient de soulever les créneaux — ses heures
										     s'effacent le temps du glissé, la place reste ouverte. -->
										<tr class="member-row" [class.slots-source]="swapSourceId === row.id_employee"
											cdkDrag [cdkDragData]="row" cdkDragPreviewClass="row-preview-wrap">
											<ng-template cdkDragPreview>
												<div class="drag-preview row-preview">
													<span class="preview-title">
														<span class="color-dot" [style.background]="row.color"></span>{{ row.name }}
													</span>
													<ng-container [ngTemplateOutlet]="weekStrip" [ngTemplateOutletContext]="{ row }"></ng-container>
												</div>
											</ng-template>

											<!-- La cellule du nom est la CIBLE d'un échange de créneaux. La liste de dépôt est
											     la cellule et non la ligne : le CDK déplace son fantôme dans le conteneur
											     survolé, et un <div> enfant de <tr> est éjecté du tableau par le navigateur —
											     la grille sautait pendant le glissé. Les cibles sont connectées par leurs
											     identifiants, jamais par un `cdkDropListGroup` : celui-ci embarquerait aussi
											     la liste des lignes ci-dessus, et l'on pourrait lâcher des créneaux dans un
											     déplacement de ligne. -->
											<td class="name-col" cdkDropList [id]="swapListId(wi, row.id_employee)"
												[cdkDropListConnectedTo]="swapLists[wi]" [cdkDropListData]="row"
												[cdkDropListEnterPredicate]="canSwapInto" (cdkDropListDropped)="onSwapDrop($event, wi)">

												<!-- Poignée de GAUCHE : déplacer la ligne. Elle est là où l'œil cherche une
												     prise de réordonnancement, et n'entre pas en concurrence avec le nom. -->
												<span class="row-grip" cdkDragHandle
													matTooltip="Glisser pour déplacer ce salarié et son emploi du temps dans la liste"
													[attr.aria-label]="'Déplacer la ligne de ' + row.name">
													<mat-icon>drag_indicator</mat-icon>
												</span>

												<button type="button" class="person-link" matTooltip="Voir son planning complet (tous services)"
													(click)="onPersonClick(row)">
													<span class="color-dot" [style.background]="row.color"></span>{{ row.name }}
												</button>
												@if (!row.eligible) {
													<span class="offprofile-chip" matTooltip="Rôle non admis dans ce service ou hors mobilité — renfort exceptionnel">hors profil</span>
												}

												<!-- Outils de ligne posés PAR-DESSUS la fin de la cellule : en flux, ils
												     mangeaient la largeur du nom, qui s'affichait tronqué en permanence. -->
												<span class="member-tools">
													<!-- Vraie balise <a> (et pas un router.navigate) : la fiche s'ouvre dans un
													     nouvel onglet au ctrl/shift+clic, comme n'importe quel lien. -->
													<a mat-icon-button class="open-sheet" [routerLink]="['/hr/employee', row.id_employee]"
														matTooltip="Ouvrir la fiche employé" [attr.aria-label]="'Fiche de ' + row.name">
														<mat-icon>badge</mat-icon>
													</a>
													<button mat-icon-button type="button" class="remove-member" matTooltip="Retirer du planning"
														[attr.aria-label]="'Retirer ' + row.name + ' du planning'" (click)="onRemoveMember(row.id_employee)">
														<mat-icon>close</mat-icon>
													</button>
												</span>

												<!-- Poignée du MILIEU, posée sur la limite entre la personne et ses heures :
												     ce sont les CRÉNEAUX qu'on emporte, pas la personne. Ce qui suit la souris
												     est donc la LIGNE ELLE-MÊME, à la taille de la grille : elle se décolle et
												     monte ou descend jusqu'à la ligne qui doit la recevoir.
												     `cdkDragLockAxis="y"` fait deux choses d'un coup : la bande reste sur ses
												     colonnes (elle ne part pas en biais), et la ligne visée ne dépend plus que
												     de la HAUTEUR du curseur — plus besoin de viser la cellule du nom. -->
												<span class="slots-drag" cdkDrag cdkDragLockAxis="y" [cdkDragData]="row"
													cdkDragPreviewClass="slots-preview-wrap"
													(cdkDragStarted)="onSlotsLift(row)" (cdkDragEnded)="onSlotsDropped()">
													<span class="slots-grip" cdkDragHandle (pointerdown)="onSlotsGrab($event)"
														matTooltip="Glisser les créneaux de la semaine sur un autre salarié pour les intervertir"
														[attr.aria-label]="'Intervertir les créneaux de ' + row.name">
														<mat-icon>swap_horiz</mat-icon>
													</span>
													<!-- La racine ne sert que d'ancre : le CDK la pose sur le point de saisie et lui
													     impose sa position. La bande, elle, se replace par rapport à cette ancre —
													     c'est ainsi qu'elle démarre exactement sur la ligne d'origine. -->
													<ng-template cdkDragPreview>
														<div class="slots-preview">
															<div class="slots-band" [style.left.px]="slotBand.left" [style.top.px]="slotBand.top"
																[style.width.px]="slotBand.width" [style.height.px]="slotBand.height">
																<div class="band-days" [style.left.px]="slotBand.innerLeft">
																	@for (dayIdx of visibleDayIndices; track dayIdx; let i = $index) {
																		@if (slotBand.cells[i]; as day) {
																			<div class="band-day" [style.left.px]="day.left" [style.width.px]="day.width">
																				@for (bar of row.cells[dayIdx]; track $index) {
																					<div class="band-bar" [style.left.%]="bar.left" [style.width.%]="bar.width"
																						[style.background]="row.color">{{ bar.label }}</div>
																				}
																			</div>
																		}
																	}
																</div>
															</div>
														</div>
													</ng-template>
												</span>
											</td>
											@for (dayIdx of visibleDayIndices; track dayIdx) {
												<td class="slot-cell">
													<div class="day-cell" #cell (pointerdown)="onCellPointerDown($event, wi, row, dayIdx, cell)">
														@for (c of closed[dayIdx]; track $index) {
															<div class="closed-seg" [style.left.%]="c.left" [style.width.%]="c.width"></div>
														}
														@for (t of hourTicks; track t.pct) {
															<div class="hour-line" [class.major]="t.label" [style.left.%]="t.pct"></div>
														}
														<div class="split-line" [style.left.%]="splitPct"></div>
														@for (bar of row.cells[dayIdx]; track $index) {
															<div class="bar" [style.left.%]="bar.left" [style.width.%]="bar.width"
																[style.background]="row.color" [title]="bar.title"
																(pointerdown)="onBarPointerDown($event, wi, row, dayIdx, bar, cell, 'move')">
																<span class="handle left" (pointerdown)="onBarPointerDown($event, wi, row, dayIdx, bar, cell, 'start')"></span>
																<span class="bar-label">{{ bar.label }}</span>
																<span class="handle right" (pointerdown)="onBarPointerDown($event, wi, row, dayIdx, bar, cell, 'end')"></span>
															</div>
														}
														@if (cellIssues(row, dayIdx).length > 0) {
															<mat-icon class="issue" [matTooltip]="issuesTooltip(cellIssues(row, dayIdx))">warning</mat-icon>
														}
													</div>
												</td>
											}
											<!-- Total de la PERSONNE sur la semaine, ce planning et les autres additionnés :
											     c'est ce chiffre-là qui se compare au contrat. -->
											<td class="total-col">
												<span [matTooltip]="totalTooltip(row)">{{ totalLabel(row) }}</span>
												@if (row.other_min > 0) {
													<div class="elsewhere" [matTooltip]="totalTooltip(row)">
														dont {{ hoursLabel(row.other_min) }} ailleurs
													</div>
												}
												@if (weekIssues(row).length > 0) {
													<mat-icon class="issue" [matTooltip]="issuesTooltip(weekIssues(row))">warning</mat-icon>
												}
											</td>
										</tr>
									}
									@if (grids[wi].length === 0) {
										<tr>
											<td [attr.colspan]="visibleDayIndices.length + 2" class="grid-empty">
												Personne sur ce planning : cliquez un nom ci-dessous pour l'ajouter,
												puis peignez ses horaires.
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					</mat-tab>
				}
			</mat-tab-group>

			<div class="flexrow available-row">
				<span class="available-label">Peuvent travailler ici :</span>
				@for (chip of availableChips; track chip.id) {
					<button type="button" class="person-chip" (click)="onAddChip(chip.id)">
						<span class="color-dot" [style.background]="chip.color"></span>{{ chip.name }}
						<mat-icon>add</mat-icon>
					</button>
				}
				@if (availableChips.length === 0) {
					<span class="available-none">tout le monde est déjà sur la grille (ou aucun rôle admis — voir Établissements &amp; services).</span>
				}
				<span class="spacer"></span>
				<mat-form-field class="add-other">
					<mat-label>Renfort hors profil…</mat-label>
					<mat-select [formControl]="addMemberCtrl">
						@for (e of selectableEmployees; track e.id) {
							<mat-option [value]="e.id">{{ employeeName(e.id) }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<mat-checkbox [(ngModel)]="allEmployees" [ngModelOptions]="{standalone: true}">Tous</mat-checkbox>
				<button mat-stroked-button type="button" (click)="onAddMember()" [disabled]="!addMemberCtrl.value">
					<mat-icon>person_add</mat-icon>&nbsp;Ajouter
				</button>
			</div>
		}
	</div>
</form>
